import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    width: "100vw",
    overflowY: "hidden",
    height: "100vh",
    flexDirection: "column",
    background: "#E5E5E5",
    justifyContent: " space-between",
    boxSizing: "border-box",

    '& .MuiFormLabel-root.Mui-error, & .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline, & .MuiFormHelperText-root.Mui-error, & .Mui-error input': {
      borderColor: '#CD0D15 !important',
      color: '#CD0D15 !important',
      fontSize: '14px'
    }
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    minHeight: "calc(100vh - 50px)",
    maxHeight: "calc(100vh - 50px)",
    overflowY: "auto",
    "& img": {
      margin: "32px",
    },
    "& h2": {
      margin: "24px",
    },
  },
  title: {
    fontSize: "36px",
    textTransform: "none",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    padding: "0 48px",
    background: "#fff",
    color: "#999999",
    justifyContent: "space-between",
    height: "50px",
    borderTop: "1px solid #999999",
    "& .priv": {
      display: "flex",
      gap: "15px",
      color: "#666",
      fontWeight: 700,
    },
  },
}));

export default useStyles;
